<template>
  <div class="customer-management-list">
    <!--  导出功能 -->
    <!-- <download-excel
      id="export"
      class="export-botton"
      :data="jsonData"
      name="客户管理列表.xls"
    >
    </download-excel> -->
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator-class="el-icon-arrow-left">
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div>
      <el-form :inline="true" :model="form" class="customer-form-inline">
        <el-form-item label="关键字：">
          <el-input
            class="t1"
            v-model.trim="form.keyword"
            clearable
            @clear="searchAgain"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="服务状态：" class="ml30">
          <el-select v-model="form.state" class="t2" placeholder="">
            <el-option label="开启" value="2"></el-option>
            <el-option label="关闭" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <span class="searh-btn" @click="searchList">
            <i class="el-icon-search"></i>查询
          </span>
          <span
            class="down-btn"
            v-if="getUserIdentity == 1"
            @click="exportOrder"
          >
            <i class="icon icon-shang-chuan"></i>导出Excel
          </span>
        </el-form-item>
      </el-form>
    </div>
    <el-divider v-if="tableData.length" class="divider"></el-divider>
    <div v-if="tableData.length" v-loading="tableLoading" class="table">
      <el-table
        :header-cell-style="{ color: '#222222' }"
        :cell-style="{ color: '#222222' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="epId" label="机构ID" width="100px">
        </el-table-column>
        <el-table-column prop="epName" label="企业名称"> </el-table-column>
        <el-table-column prop="contact" label="联系人" > </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>

        <el-table-column prop="customerChannel" label="客户类型">
           <template slot-scope="scope">
            <span>{{
              scope.row.customerChannel | formatCustomerChannel
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="审核状态">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.state === 3 ? '#E10000' : '' }">{{
              scope.row.state | state
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务状态">
          <template slot-scope="scope">
            <span>{{
              scope.row.appState === 1
                ? '已开启'
                : scope.row.appState === 2
                ? '已暂停'
                : '未创建'
            }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="createTime" label="注册时间"> </el-table-column>
        <el-table-column  label="操作" width="200px">
          <template slot-scope="scope">
            <span @click="toDetail(scope.row)" class="detail">详情</span>
            <!-- <span
              v-show="scope.row.appState === 1"
              @click="serverClick(scope.row)"
              class="suspend"
              >服务暂停</span
            >
            <span
              @click="serverClick(scope.row)"
              v-show="scope.row.appState === 2"
              class="start"
              >服务开启</span
            > -->
            <span
              v-if="scope.row.customerChannel != 0 && getUserIdentity == 4"
              @click="addFinancial(scope.row)"
              class="suspend"
              >财务录入</span
            >
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total > 0" class="pagination">
        <Pagination
          :total="total"
          :pageSize="pageSize"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :currentPage="currentPage"
        ></Pagination>
      </div>

    <!-- 导出的列表  start-->
     <el-table
        id="customerManagerTable"
        :data="jsonData"
        style="width: 100%;display:none"
      >
        <el-table-column prop="epId" label="机构ID" width="100px">
        </el-table-column>
        <el-table-column prop="epName" label="企业名称"> </el-table-column>
        <el-table-column prop="contact" label="联系人" > </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>

        <el-table-column prop="customerChannel" label="客户类型">
           <template slot-scope="scope">
            <span>{{
              scope.row.customerChannel | formatCustomerChannel
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间"> </el-table-column>
      </el-table>
      <!-- 导出的列表  end-->
    </div>
    <!-- 如果是查询的单条数据添加返回充值按钮   -->
    <div
      style="margin-top: 20px;text-align: center;"
      v-if="tableData.length && this.form.keyword"
    >
      <el-button class="research-button" @click="toBackList">返回</el-button>
    </div>
    <!-- 未找到相关数据 -->
    <div class="no-data-wrap" v-if="!tableData.length">
      <div class="tc"><i class="icon icon-no-data icon-size"></i></div>
      <div class="no-data-desc tc">暂无数据</div>
      <el-button class="research-button" @click="toBackList">返回</el-button>
    </div>
    <el-dialog
      :append-to-body="true"
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <p style="text-align: center;line-height: 60px">
        您确定要{{
          activeUser.appState === 1 ? '暂停' : '启用'
        }}该客户的存证服务么？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="clicked"
          round
          type="primary"
          @click="editServerStatus"
          >确 定</el-button
        >
        <el-button round @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'
import Pagination from '@/components/common/Pagination.vue'
// import JsonExcelVue from 'vue-json-excel'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  name: 'CustomerManagementList',
  components: {
    Pagination,
  },
  data() {
    return {
      jsonData: [],
      tableData: [],
      currentPage: 1,
      tableLoading: false,
      dialogVisible: false,
      activeUser: {},
      clicked: false,
      total: 0, // 总页数
      pageSize: 10, // 每页显示条数
      form: {
        keyword: '',
        state: '2',
      },
      query: null,
    }
  },
  created() {
    window.onbeforeunload = e => { // 刷新时弹出提示
      sessionStorage.getItem('query') && sessionStorage.removeItem('query')
    };
    let req = null
    if (sessionStorage.getItem('query')) {
      req = sessionStorage.getItem('query')
      this.query = JSON.parse(req)
      this.currentPage = this.query.start
      this.form.keyword = this.query.epName
      this.pageSize = this.query.count;
    } else {
      req = {
        epName: this.form.keyword,
        state: this.form.state,
        count: this.pageSize,
        start: this.currentPage,
        isAgent:false,
        agentId:0
      }
      this.query = JSON.parse(JSON.stringify(req))
    }
    this.getCustomerManagementList()
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 详情和财务录入的时候，返回列表的时候保持原筛选条件
    if (['customerDetail', 'addFinancialInfo'].includes(to.name)) {
      this.query.epName = decodeURIComponent(this.query.epName);
      sessionStorage.setItem("query", JSON.stringify(this.query));
    } else {
      sessionStorage.removeItem('query')
    }
    // if (to.name !== 'customerDetail') {
    //   sessionStorage.removeItem('query')
    // }
    next()
  },
  beforeUpdate() {
    this.query.epName = decodeURIComponent(this.query.epName);
    sessionStorage.setItem('query', JSON.stringify(this.query))
  },
  filters: {
    state: (val) => {
      let status = ''
      switch (val) {
        case 1:
          status = '待审核'
          break
        case 2:
          status = '已通过'
          break
        case 3:
          status = '未通过'
          break
        default:
          status = ''
      }
      return status
    },
  },
  computed: {
    getUserIdentity() {
      return getStorageItem('loginInfo').roleID
    },
  },
  methods: {
    searchAgain(){
       const req = {
        epName: this.form.keyword,
        state: this.form.state,
        count: this.pageSize,
        start: this.currentPage,
        agentId:0
      }
      this.query = JSON.parse(JSON.stringify(req))
      this.getCustomerManagementList()
    },
    toBackList() {
      this.currentPage = 1
      this.pageSize = 10
      this.form.keyword = ''
      this.query.epName = ''
      this.query.start = 1
      this.query.count = 10
      this.getCustomerManagementList()
    },
    editServerStatus() {
      // 修改企业服务状态
      const req = {
        epId: this.activeUser.epId,
        reason: 'ok',
      }
      this.clicked = true
      const opereateStatus =
        this.activeUser.appState === 1 ? 'disableUser' : 'enableUser'
      Api.customer[opereateStatus](req)
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            this.getCustomerManagementList()
            this.dialogVisible = false
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
          } else {
            this.$message.closeAll()
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: 'error',
            })
          }
          this.clicked = false
        })
        .catch(() => {
          this.clicked = false
        })
    },
    serverClick(row) {
      // 点击开启或暂停服务按钮
      this.dialogVisible = true
      this.activeUser = row
    },
    addFinancial(row) {
      setStorageItem('epDetail', row) // 储存企业详情，用于财务录入信息展示
      // 添加财务
      this.$router.push({
        name: 'addFinancialInfo',
        query: {
          mobile: row.mobile,
        },
      })
    },
    exportOrder() {
      const req = {
        epName: this.form.keyword || '',
        state: this.form.state || '-1',
        limitCount: 1000 // 导出的页数
      }
      Api.customer.exportCustomerInfor(req).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.jsonData = res.detail
          this.$nextTick(()=>{
              /* generate workbook object from table */
              var xlsxParam = { raw: true }
              let wb = XLSX.utils.table_to_book(document.querySelector('#customerManagerTable'),xlsxParam);
              /* get binary string as output */
              let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
              try {
                  FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '客户管理列表.xlsx');
              } catch (e)
              {
                if (typeof console !== 'undefined')
                console.log(e, wbout)
              }
              return wbout
          })
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error',
          })
        }
      })
      
    },
    searchList() {
      if (!this.form.keyword) {
        this.$message.warning('请正确输入查询条件')
        return
      }
      this.currentPage = 1
      this.pageSize = 10
      this.query.start = 1
      this.query.count = 10
      this.query.epName = this.form.keyword
      this.getCustomerManagementList({ showTip: true })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.query.count = val
      this.getCustomerManagementList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.query.start = val
      // 分页操作
      this.getCustomerManagementList()
    },
    getCustomerManagementList(obj) {
      // 获取企业列表
      this.tableLoading = true
      // const req = {
      //   epName: this.form.keyword,
      //   state: this.form.state,
      //   count: this.pageSize,
      //   start: this.currentPage,
      // }
      this.query.epName = encodeURIComponent(this.query.epName);
      return Api.customer
        .customerManagementList(this.query)
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            // 2020.2.26 临时修修改用户状态 0客户未定，保留留以前模式， 1官⽹网客户， 2腾 讯内部
            if (obj && obj.showTip && res.detail && res.detail.length) {
              this.$message({
                showClose: true,
                message: '查询成功',
                type: 'success',
              })
            }
            this.tableData = res.detail
            this.total = res.total
          } else {
            this.$message.closeAll()
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: 'error',
            })
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    toDetail(row) {
      // 点击详情跳转至详情页
      console.log('row', row)
      if (row.epId === 92) {
        // 强制修改成官网用户
        // row.customerChannel = 2
      }
      setStorageItem('epDetail', row) // 储存企业详情，用于详情页面展示
      this.$store.commit('setCustomerTab', 'customerFirst')
      this.$router.push({
        name: 'customerDetail',
        query: {
          from: 'manage',
          epId: row.epId,
          customerChannel: row.customerChannel,
          userType:row.userType
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-management-list {
  .export-botton {
    display: none;
  }
  width: 100%;
  min-height: calc(100vh - 110px);
  background-color: #ffffff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .table {
    .el-table {
      padding: 30px;
      padding-bottom: 0;
      .detail {
        color: #1e4499;
        cursor: pointer;
        margin-right: 10px;
      }
      .suspend,
      .start {
        color: #1e4499;
        cursor: pointer;
        padding-left: 10px;
        padding-right: 10px;
        border-left: 1px solid #e5e5e5;
      }
      .start {
        color: #43a30f;
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog__footer {
      margin-top: -20px;
      text-align: center;
      .el-button {
        width: 134px;
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
  .customer-form-inline ::v-deep {
    margin: 20px 30px 0 30px;
    .t1 {
      width: 280px;
    }
    .ml30 {
      margin-left: 30px;
    }
    .t2 {
      width: 200px;
    }
    .el-input__inner {
      height: 36px;
    }
    .searh-btn {
      display: inline-block;
      margin-left: 25px;
      width: 90px;
      height: 36px;
      line-height: 34px;
      color: #fff;
      text-align: center;
      background: linear-gradient(
        90deg,
        rgba(248, 194, 80, 1),
        rgba(246, 170, 9, 1)
      );
      box-shadow: 0px 0px 3px 0px rgba(246, 186, 58, 0.27);
      border-radius: 4px;
      border: none;
      font-weight: 500;
      font-size: 16px;
      cursor: pointer;
      i {
        margin-right: 8px;
      }
    }
    .down-btn {
      cursor: pointer;
      margin-left: 10px;
      text-align: center;
      width: 120px;
      height: 36px;
      line-height: 34px;
      display: inline-block;
      color: #fff;
      background: linear-gradient(
        90deg,
        rgba(32, 73, 163, 1),
        rgba(29, 96, 192, 1)
      );
      box-shadow: 0px 2px 3px 0px rgba(29, 96, 192, 0.44);
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      i {
        margin-right: 8px;
      }
    }
  }
  ::v-deep .el-divider--horizontal {
    margin: 0;
  }
}
.no-data-wrap {
  margin-top: 100px;
  text-align: center;
}
.tc {
  text-align: center !important;
}
.icon-size {
  font-size: 120px;
}
.no-data-desc {
  padding: 15px 0 15px 0;
}
.research-button {
  color: #fff;
  margin-bottom: 20px;
  width: 90px;
  background-color: #2b4ca0;
}
</style>
